module.exports = __webpack_public_path__ + "static/media/nunito-sans-v15-cyrillic_cyrillic-ext_latin_latin-ext_vietnamese-regular.e0c9d0f2.woff2";